/**
 * Creates an object composed of the picked properties from the `source` object.
 * @example
 * const object = { foo: 0, bar: 1, baz: 2 };
 * pick(object, ['bar', 'baz']);
 * // => { bar: 1, baz: 2 }
 *
 * @function pick
 * @param {Object} source The object to pick from.
 * @param {(string[]|string)} path The property path(s) to pick.
 * @return {Object} Returns an object with the picked properties.
 */
export default function pick(source, path) {
	const values = {};
	if (!path || !path.length || !source) return {};

	const paths = typeof path === 'string' ? [path] : path;
	const {length: pathLength} = paths;
	for (let i = 0; i < pathLength; i++) {
		const key = paths[i];
		if (source.hasOwnProperty(key)) values[key] = source[key];
	}

	return values;
}
